import { useEffect, useState } from 'react';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';

const CheckboxGroup = ({ id, name, type, typeName, order, label, required, options, input, meta }) => {

  const [checkedValues, setCheckedValues] = useState({});
  const [values, setValues] = useState({});

  // when component is already mount
  useEffect(() => {
    if (options.length > 0) {
      const defaultValues = {}
      const customValues = {}
      for (let option of options) {
        // console.log(option.id, option.value);
        if (option.default) {
          defaultValues[option.id] = { ...option };
        }
        if (option.typeName === 'CUSTOM_OPTION') {
          customValues[option.id] = option.value;
          setValues(customValues);
        }
        // console.log(defaultValues, customValues, values);
      }
      setCheckedValues(defaultValues);
      // Set default options
      if (Object.keys(defaultValues).length > 0) {
        input.onChange({
          id,
          typeName, //type,
          order,
          result: options.filter(option => defaultValues[option.id])
        });
      }
    }
  }, []);

  const handleChange = (event, option) => {
    const newValues = { ...checkedValues };
    newValues[option.id] = event.target.checked ? { ...option, value: values[option.id] } : null;
    // console.log('handleChange', event.target.checked, values, newValues, checkedValues);

    if (option.typeName === "CANCEL_OPTION") {
      Object.keys(newValues).forEach(key => {
        // FYI: key and option.id are different types, do not use "===", use ""=="
        if (!(key == option.id && event.target.checked)) {
          // console.log('option.id', option.id)
          delete newValues[key];
        }
      });
    } else {
      Object.keys(newValues).forEach(key => {
        if (newValues[key]?.typeName === "CANCEL_OPTION") {
          delete newValues[key];
        }
      });
    }

    setCheckedValues(newValues);
    // console.log('handleChange', event.target.checked, newValues, values, option, { ...option, ...{ value: values[option.id] } });

    if (Object.keys(newValues)?.filter(checkBox => !!newValues[checkBox])?.length > 0) {
      const result = options.map(op => {
        return {
          ...op,
          value: newValues[op.id]?.value
        };
      });

      // console.log('!result', result, result.filter(res => newValues[res.id]))

      input.onChange({
        id,
        typeName,
        order,
        result: result.filter(res => newValues[res.id])
      });
    } else {
      input.onChange(null);
    }
  }

  const handleCustomOptionChange = (event, option) => {
    const newValues = { ...checkedValues };
    newValues[option.id].value = event.target.value;
    const customValues = { ...values };
    setCheckedValues(newValues);

    // console.log('handleCustomOptionChange', event.target.value)

    if (Object.keys(newValues)?.filter(checkBox => !!newValues[checkBox])?.length > 0) {
      const result = options.map(op => {
        if (op.id === option.id) {
          return {
            ...op,
            value: event.target.value
          }
        }
        return {
          ...op,
          value: newValues[op.id]?.value
        };
      });

      // console.log('!result', result.filter(res => newValues[res.id]))

      if (option.typeName === 'CUSTOM_OPTION') {
        customValues[option.id] = newValues[option.id].value;
        setValues(customValues);
      }

      input.onChange({
        id,
        typeName,
        order,
        result: result.filter(res => newValues[res.id])
      });
    } else {
      input.onChange(null);
    }
  }

  return (
    <div>
      <FormGroup>
        {options.map((option, index) => (
          <div key={index}>
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={!!checkedValues[option.id]}
                  onChange={(event) => handleChange(event, option)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              }
              label={option.label} />
            {
              option.typeName === 'CUSTOM_OPTION' && !!checkedValues[option.id] &&
              <TextField
                size="small"
                fullWidth
                value={values[option.id] || ""}
                onChange={(e) => {
                  handleCustomOptionChange(e, option);
                }}
              // style={{ width: '50%' }}
              />
            }
          </div>
        ))}
      </FormGroup>
      {/* {options.map((option, index) => (
          <div className="checkbox" key={index}>
            <label>
              <input type="checkbox"
                name={`${input.label}[${index}]`}
                checked={!!checkedValues[option.id]}
                onChange={(event) => handleChange(event, option)}
              />
              {option.label}
            </label>
          </div>
        )
      )} */}
      {/* {options.map((option, index) => (
          <div className="checkbox" key={index}>
            <label>
              <input type="checkbox"
                name={`${input.label}[${index}]`}
                // value={JSON.stringify(option)}
                value={option.id}
                checked={input.value.findIndex(item => item.id === option.id) !== -1}
                onChange={(event) => {
                  const newValue = [...input.value];
                  if (event.target.checked) {
                    newValue.push(option);
                  } else {
                    newValue.splice(newValue.findIndex(item => item.id === option.id), 1);
                  }
                  return input.onChange(newValue);
                }}/>
              {option.label}
            </label>
          </div>
        )
      )} */}
    </div>
  );
}

export default CheckboxGroup;